import isequal from 'lodash.isequal';

import { filtersBlankState, filtersInitialState } from './filtersInitialState';
import { SettingsService } from 'services/settings';
import { TFiltersModel } from './filtersModel';
import { VESSEL_TYPE_IDS } from '../../pages/Map/controls/MapControlPane/VesselMenu/vesselTypes';

/** Defines whether current settings are different from the initial ones. */
export function isFarmFilterSet(
  settings: TFiltersModel = filtersInitialState
): boolean {
  const { companyValue, countryValue, facilityValue, fleetValue, specieValue } =
    filtersBlankState;

  const blank = {
    companyValue,
    countryValue,
    facilityValue,
    fleetValue,
    specieValue
  };

  const current = {
    companyValue: settings.companyValue,
    countryValue: settings.countryValue,
    facilityValue: settings.facilityValue,
    fleetValue: settings.fleetValue,
    specieValue: settings.specieValue
  };

  return !isequal(blank, current);
}

/** Defines whether current settings are different from the initial ones. */
export function isVesselFilterSet(
  settings: TFiltersModel = filtersInitialState
): boolean {
  const {
    buildYearValue,
    companyValue,
    countryValue,
    engineModelValue,
    enginePowerValue,
    fleetValue,
    lengthValue,
    tonnageValue,
    vesselTypeValue
  } = filtersBlankState;

  const blank = {
    buildYearValue,
    companyValue,
    countryValue,
    engineModelValue,
    enginePowerValue,
    fleetValue,
    lengthValue,
    tonnageValue,
    vesselTypeValue
  };

  const current = {
    buildYearValue: settings.buildYearValue,
    companyValue: settings.companyValue,
    countryValue: settings.countryValue,
    engineModelValue: settings.engineModelValue,
    enginePowerValue: settings.enginePowerValue,
    fleetValue: settings.fleetValue,
    lengthValue: settings.lengthValue,
    tonnageValue: settings.tonnageValue,
    vesselTypeValue: settings.vesselTypeValue
  };

  return !isequal(blank, current);
}

/**
 *
 * @param settings
 */
export function storeSettings(settings: TFiltersModel): void {
  SettingsService.writeSettings({ [SettingsService.MAIN_FILTER]: settings });
}

/**
 *
 */
export function getFilterUpdate(
  value: Partial<TFiltersModel>,
  settings: TFiltersModel
): TFiltersModel {
  const vesselTypes =
    'vesselTypeValue' in value
      ? handleVesselTypes(value.vesselTypeValue)
      : settings.vesselTypeValue;

  // It's called 'partial' because we still need to update 'isFilterSet'.
  const partialUpdate: TFiltersModel = {
    ...settings,
    ...value,
    vesselTypeValue: vesselTypes
  };

  return {
    ...partialUpdate,
    isFarmFilterSet: isFarmFilterSet(partialUpdate),
    isVesselFilterSet: isVesselFilterSet(partialUpdate)
  };
}

/**
 *
 */
function handleVesselTypes(types: number[] | null): number[] | null {
  if (!types) return types;

  const vesselType = dedupeTypes(types);
  return isequal(vesselType, VESSEL_TYPE_IDS) ? [] : vesselType;
}

/**
 *
 */
function dedupeTypes(types: number[]): number[] {
  const set = new Set(types);
  return [...set].sort();
}
